/* SpeedBox 24 — wspólne efekty: śnieg, pojawianie, odliczanie, iskry, licznik */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SB=window.SB=window.SB||{};

  /* iskry / konfetti w punkcie (x,y) */
  SB.burst=function(x,y,opts){
    if(reduce)return;opts=opts||{};
    var colors=opts.colors||['#ff2b2b','#ffc23d','#22c56b','#2f8dff','#ffffff','#ff7a1a'];
    var n=opts.count||28;
    for(var i=0;i<n;i++){(function(){
      var el=document.createElement('span');el.className='sb-spark';
      el.style.background=colors[Math.floor(Math.random()*colors.length)];
      el.style.left=x+'px';el.style.top=y+'px';
      if(Math.random()<.35)el.style.borderRadius='50%';
      document.body.appendChild(el);
      var a=Math.random()*Math.PI*2,v=90+Math.random()*(opts.power||170);
      var dx=Math.cos(a)*v,dy=Math.sin(a)*v-80,rot=(Math.random()-.5)*720;
      var anim=el.animate([
        {transform:'translate(-50%,-50%) rotate(0)',opacity:1},
        {transform:'translate('+dx+'px,'+(dy+160)+'px) rotate('+rot+'deg)',opacity:0}
      ],{duration:900+Math.random()*600,easing:'cubic-bezier(.15,.7,.3,1)'});
      anim.onfinish=function(){el.remove()};
    })();}
  };

  /* odliczanie: [data-sb-countdown="ISO"] z dziećmi [data-d],[data-h],[data-m],[data-s] */
  function pad(n){return(n<10?'0':'')+n}
  function initCountdowns(){
    document.querySelectorAll('[data-sb-countdown]').forEach(function(el){
      if(el.__sb)return;el.__sb=1;
      var t=Date.parse(el.getAttribute('data-sb-countdown'));
      if(isNaN(t)){el.hidden=true;return;}
      var d=el.querySelector('[data-d]'),h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]');
      var wrap=el.closest('[data-sb-countdown-wrap]');
      function tick(){
        var diff=Math.max(0,t-Date.now());
        if(diff<=0){if(wrap)wrap.hidden=true;else el.hidden=true;clearInterval(iv);return;}
        var sec=Math.floor(diff/1000);
        if(d)d.textContent=Math.floor(sec/86400);
        if(h)h.textContent=pad(Math.floor(sec%86400/3600));
        if(m)m.textContent=pad(Math.floor(sec%3600/60));
        if(s)s.textContent=pad(sec%60);
      }
      var iv=setInterval(tick,1000);tick();
    });
  }

  /* pojawianie przy przewijaniu + liczniki */
  function initReveal(){
    var els=document.querySelectorAll('.sb-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('is-in')});countAll(true);return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){
      if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}
    })},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e,i){e.style.transitionDelay=(e.getAttribute('data-delay')||0)+'ms';io.observe(e)});
    var cio=new IntersectionObserver(function(entries){entries.forEach(function(en){
      if(en.isIntersecting){countUp(en.target);cio.unobserve(en.target);}
    })},{threshold:.4});
    document.querySelectorAll('[data-sb-count]').forEach(function(e){cio.observe(e)});
  }
  function countUp(el,instant){
    var to=parseFloat(el.getAttribute('data-sb-count'));if(isNaN(to))return;
    if(instant||reduce){el.textContent=to;return;}
    var start=performance.now(),dur=1400;
    function step(now){var p=Math.min(1,(now-start)/dur);p=1-Math.pow(1-p,3);el.textContent=Math.round(to*p);if(p<1)requestAnimationFrame(step);}
    requestAnimationFrame(step);
  }
  function countAll(instant){document.querySelectorAll('[data-sb-count]').forEach(function(e){countUp(e,instant)})}

  /* śnieg */
  function initSnow(){
    var c=document.getElementById('sb-snow');if(!c||reduce)return;
    var ctx=c.getContext('2d'),W,H,dpr=Math.min(window.devicePixelRatio||1,2),flakes=[];
    var base=parseInt(c.getAttribute('data-density')||'50',10);
    function size(){W=c.clientWidth;H=c.clientHeight;c.width=W*dpr;c.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);}
    size();window.addEventListener('resize',size);
    var n=Math.round(base*(W<700?.6:1));
    for(var i=0;i<n;i++)flakes.push({x:Math.random()*W,y:Math.random()*H,r:.6+Math.random()*2.2,s:.3+Math.random()*.9,w:Math.random()*Math.PI*2,o:.25+Math.random()*.6});
    var run=true;document.addEventListener('visibilitychange',function(){run=!document.hidden;if(run)requestAnimationFrame(loop)});
    function loop(){if(!run)return;ctx.clearRect(0,0,W,H);
      for(var i=0;i<flakes.length;i++){var f=flakes[i];f.y+=f.s;f.w+=.012;f.x+=Math.sin(f.w)*.35;
        if(f.y>H+4){f.y=-4;f.x=Math.random()*W}
        ctx.beginPath();ctx.arc(f.x,f.y,f.r,0,Math.PI*2);ctx.fillStyle='rgba(255,255,255,'+f.o+')';ctx.fill();}
      requestAnimationFrame(loop);}
    requestAnimationFrame(loop);
  }

  SB.init=function(){initCountdowns();initReveal();};
  function boot(){SB.init();initSnow();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',SB.init);
})();
